import { render, staticRenderFns } from "./o-slide-projector.vue?vue&type=template&id=72add2a5"
import script from "./o-slide-projector.vue?vue&type=script&lang=js"
export * from "./o-slide-projector.vue?vue&type=script&lang=js"
import style0 from "./o-slide-projector.vue?vue&type=style&index=0&id=72add2a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports